import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import ReactMarkdown from 'react-markdown';
import { Link } from 'gatsby';

export const Fitin56Banner = ({ info }: any) => {
  return (
    <div className={`fitin56-banner ${info.backgroundColor?.toLowerCase()}`}>
      <div className="container">
        <div className="fitin56-banner-wrapper">
          {info.image && (
            <div className="fitin56-banner-image">
              <GatsbyImage
                image={info.image.localFile.childImageSharp.gatsbyImageData}
                alt={info.image?.alternativeText ?? ''}
              />
            </div>
          )}
          <div
            className={`fitin56-banner-content ${
              !info.image && 'center-align'
            }`}
          >
            <ReactMarkdown className="fitin56-banner-content-tagline">
              {info.title}
            </ReactMarkdown>
            <ReactMarkdown className="fitin56-banner-content-summary">
              {info.summary}
            </ReactMarkdown>
            {info.ctaButton && (
              <Link to={info.ctaLink}>
                <button type="button" className="fitin56-banner-content-cta">
                  {info.ctaButton}
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
